import { render } from "./check-card-wrapped.vue?vue&type=template&id=533afe23"
import script from "./check-card-wrapped.vue?vue&type=script&lang=js"
export * from "./check-card-wrapped.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__